import React from 'react';
import styles from './RelatedPersons.module.scss';
import { Form } from 'antd';
import DropdownSelect from '../../../../../../components/dropdownSelect';
import {
  getDocOptionsOrgsSelect,
  getDocOptionsWorkersSelect,
} from '../../../../utils/getDocOptionsSelect';
import { getRenderControl } from '../../../../../../components/SingleControlCustom/getRenderControl';
import useExecuterListQuery from '../../../../queries/useExecuterListQuery';
import useWorkersListQuery from '../../../../queries/useWorkersListQuery';
import useOrgsDocsQuery from '../../../../queries/useOrgsDocsQuery';
import { useDispatch, useSelector } from 'react-redux';
import { docTypes } from '../../../../constants/documents.constants';
import {
  applyCreator,
  applyExecuter,
  applyOrgs,
  applyResponsibleWorker,
} from '../../../../store/actions/documentFilterNew.actions';

const RelatedPersons = () => {
  const {
    executerId,
    responsibleWorkerId,
    orgsIds,
    creatorIds,
    typeId,
    companyId,
  } = useSelector((state) => state.documentFilterNewStore);

  const dispatch = useDispatch();

  const { data: executerList = [], isFetching: isExecuterFetching } =
    useExecuterListQuery({ serviceCompanyId: companyId });
  const { data: workersList = [], isFetching: isWorkersFetching } =
    useWorkersListQuery({ serviceCompanyId: companyId });
  const { data: orgsList = [], isFetching: isOrgsFetching } =
    useOrgsDocsQuery(companyId);

  const showOrgs = typeId !== docTypes.citizenAppeal;

  const handleChangeExecuter = (value) => {
    dispatch(applyExecuter(value));
  };

  const handleChangeResponsibleWorker = (value) => {
    dispatch(applyResponsibleWorker(value));
  };

  const handleChangeOrgs = (value) => {
    dispatch(applyOrgs(value));
  };

  const handleChangeCreator = (value) => {
    dispatch(applyCreator(value));
  };

  return (
    <div className={styles.root}>
      <Form.Item
        label="Исполнитель"
        className={styles.item}
      >
        <DropdownSelect
          value={executerId}
          onChange={(value) => handleChangeExecuter(value)}
          multiple={false}
          options={getDocOptionsWorkersSelect(executerList)}
          renderControl={getRenderControl({
            options: getDocOptionsWorkersSelect(executerList),
            isClear: true,
            onClearClick: () => {
              handleChangeExecuter(null);
            },
            value: executerId,
            placeholder: 'Выберите из списка',
            disabled: isExecuterFetching,
            loading: isExecuterFetching,
          })}
        />
      </Form.Item>
      <Form.Item
        label="Ответственнный"
        className={styles.item}
      >
        <DropdownSelect
          value={responsibleWorkerId}
          onChange={(value) => handleChangeResponsibleWorker(value)}
          multiple={false}
          options={getDocOptionsWorkersSelect(workersList)}
          renderControl={getRenderControl({
            options: getDocOptionsWorkersSelect(workersList),
            isClear: true,
            onClearClick: () => {
              handleChangeResponsibleWorker(null);
            },
            value: responsibleWorkerId,
            placeholder: 'Выберите из списка',
            disabled: isWorkersFetching,
            loading: isWorkersFetching,
          })}
        />
      </Form.Item>
      {showOrgs && (
        <Form.Item
          label="Организация"
          className={styles.item}
        >
          <DropdownSelect
            value={orgsIds}
            onChange={(value) => handleChangeOrgs(value)}
            disabled={isOrgsFetching}
            loading={isOrgsFetching}
            multiple={true}
            options={getDocOptionsOrgsSelect(orgsList)}
          />
        </Form.Item>
      )}
      <Form.Item
        label="Автор"
        className={styles.item}
      >
        <DropdownSelect
          value={creatorIds}
          onChange={(value) => handleChangeCreator(value)}
          disabled={isExecuterFetching}
          loading={isExecuterFetching}
          multiple={true}
          options={getDocOptionsWorkersSelect(executerList)}
        />
      </Form.Item>
    </div>
  );
};

export default RelatedPersons;
